import { Metamodel } from '../base/model';
import { IModel, IAttribute } from '../base/annotation';
import { LinkedService } from '../linkedservice/linkedservice';

import { AzureKeyVault } from 'app/model/linkedservice/key-vault';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.db2.linkedServiceType,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.Db2_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.Db2_DisplayText)
    ]
})
export class Db2LinkedService extends LinkedService {

    public static readonly MODEL: IModel;
    public static readonly SERVER_NAME: IAttribute;
    public static readonly DATABASE_NAME: IAttribute;
    public static readonly SCHEMA: IAttribute;
    public static readonly AUTHENTICATION_TYPE: IAttribute;
    public static readonly USER_NAME: IAttribute;
    public static readonly PASSWORD: IAttribute;
    public static readonly PACKAGE_COLLECTION: IAttribute;
    public static readonly CERTIFICATE_COMMON_NAME: IAttribute;

    @Metamodel.attribute({
        display: stringResources.ModelName_ServerName,
        association: 'SERVER_NAME',
        templatable: true
    })
    public server?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_DatabaseName,
        association: 'DATABASE_NAME',
        templatable: true
    })
    public database?: string;

    @Metamodel.attribute({
        display: stringResources.Schema,
        association: 'SCHEMA',
        templatable: true
    })
    public schema?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_AuthenticationType,
        association: 'AUTHENTICATION_TYPE',
        templatable: true
    })
    public authenticationType?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_UserName,
        association: 'USER_NAME',
        templatable: true
    })
    public username?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Password,
        constraint: {
            validator: validateAKVLinkedserviceReference
        },
        association: 'PASSWORD',
        templatable: true,
        accepts: ['String']
    })
    public password?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_PackageCollection,
        association: 'PACKAGE_COLLECTION',
        templatable: true
    })
    public packageCollection?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_CertificateCommonName,
        association: 'CERTIFICATE_COMMON_NAME',
        templatable: true
    })
    public certificateCommonName?: string;

    public isOldMashupResource: boolean = false; // for existing linked service
    public isMashupResource: boolean = false; // for both new and existing linked service

    public enableAKV?: boolean = false;

    @Metamodel.attribute({
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public referedAKV?: AzureKeyVault;

    constructor(name?: string, description?: string) {
        super(name, description);
    }
}
